import { Pipe, PipeTransform } from '@angular/core';
import { KeyFigureElement, KeyFigureValue } from '../../index';
/*
 * Takes a keyfigureelement array and transforms to standard json object.
 * Elements in array containing key value pairs will be flattened to one object where each
 * key value pair becomes properties and values in the returned object.
 */
@Pipe({ name: 'toFlatObjectModel' })
export class SbKeyFigureToFlatmodelPipe implements PipeTransform {
    transform(value: KeyFigureElement[]): object {
        const result = {};
        if (value) {
            // Hacky way of handling removal of key.
            if (value.length === 1 && value[0].key === 'key') {
                return this.getFlattenedValue(value[0].values);
            }
            value.forEach((kfe) => {
                result[kfe.key] = this.getFlattenedValue(kfe.values);
            });
        }
        return result;
    }
    getFlattenedValue(values: KeyFigureValue[]): any {
        if (values.length === 1) {
            // If only one value - assume that value is the value we are after.
            return values[0].value;
        }
        // else assume each value has it's own field key. (such as each item in the account section / multiple subfields for each key value)
        const result = {};
        values.forEach((kfv) => {
            result[kfv.field] = kfv.value;
        });
        return result;
    }
}
